import { FC } from 'react';

import { Form, FormItemProps, Input, InputProps } from 'antd';
import classNames from 'classnames';

import './InputFormItem.scss';

type TInputFormItemProps = {
	formItemProps: FormItemProps;
	inputProps: InputProps;
};

export const InputFormItem: FC<TInputFormItemProps> = ({ formItemProps, inputProps }) => {
	return (
		<Form.Item
			{...formItemProps}
			className={classNames('input', formItemProps.className)}
			rules={formItemProps?.rules ?? [{ required: true }]}
		>
			<Input {...inputProps} />
		</Form.Item>
	);
};
